import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

export type ApiResponse<T> = {
  code: number;
  msg: string;
  data: T;
};

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) =>
    (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
};

export const unwrapApiResponse = <T>(response: ApiResponse<T>): T => {
  if (response.code !== 200) {
    throw new Error(response.msg);
  }
  return response.data;
};

export const createAppRequest = () => {
  const request = createRequest(BizAppConfig.appApiUrl);
  return async <T = unknown>(
    url: string,
    options?: ScopedRequestOptions,
  ): Promise<T> => {
    const response = await request<ApiResponse<T>>(url, options);
    return unwrapApiResponse(response);
  };
};
export const createTenantManagementRequest = () =>
  createRequest(BizAppConfig.appTenantManagementUrl);
